document.addEventListener('DOMContentLoaded', function() {
    setupCarousel('uk');
    setupCarousel('na');
});

function setupCarousel(prefix) {
    const slides = document.querySelectorAll(`.carousel-slide-${prefix}`);
    const dots = document.querySelectorAll(`.carousel-dot-${prefix}`);
    const carouselWrapper = document.querySelector(`.carousel-wrapper-${prefix}`);

    // console.log(`carousel-slide-${prefix}`, slides);
    // console.log(`carousel-dot-${prefix}`, dots);
    // console.log(`carousel-wrapper-${prefix}`, carouselWrapper);

    if (carouselWrapper && dots.length > 0) {
        dots.forEach((dot, index) => {
            dot.addEventListener('click', function() {
                updateCarousel(carouselWrapper, index);
                setActiveDot(dots, index);
            });
        });

        if (dots.length > 0) {
            dots[0].classList.add('active');
        }
    }
}

function updateCarousel(carouselWrapper, slideIndex) {
    let offset = -slideIndex * 100;
    carouselWrapper.style.transform = `translateX(${offset}%)`;
}

function setActiveDot(dots, slideIndex) {
    dots.forEach(dot => {
        dot?.classList.remove('active');
    });
    dots[slideIndex]?.classList.add('active');
}
